<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Overview</span>
        <h3 class="page-title">Register Details</h3>
      </div>
    </div>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <div class="card-header border-bottom">
            <!-- <h6 class="m-0">
              <router-link :to="{ name: 'RegisterAdd'}">
                <button
                  class="btn btn-md btn-primary"
                  style="background-color:white;color:black;"
                >Add New</button>
              </router-link>
            </h6>-->
          </div>
          <div class="card-body p-0 pb-3 text-center">
            <div class="row">
              <div class="col">
                <div class="grid-row" layout="row top-stretch">
                  <div class="grid-cell">
                    <paginator
                      :source="Register.DataModel.Data.RegisterList"
                      :filter="Register.GridInfo.RegisterInfoGrid.AdditionalInfo.filter"
                      :page-size="Register.GridInfo.RegisterInfoGrid.AdditionalInfo.pageSize"
                      data-intro="Use the paginator to page data for easier viewing"
                      data-step="10"
                      data-position="top"
                    >
                      <template scope="page">
                        <datatable
                          id="data-table-main"
                          :source="page.data"
                          :filterable="false"
                          :striped="Register.GridInfo.RegisterInfoGrid.AdditionalInfo.striped"
                          :editable="Register.GridInfo.RegisterInfoGrid.AdditionalInfo.editable"
                          :line-numbers="Register.GridInfo.RegisterInfoGrid.AdditionalInfo.lineNumbers"
                        >
                          <datatable-column
                            v-for="column in Register.GridInfo.RegisterInfoGrid.columns"
                            :id="column.id"
                            :label="column.label"
                            :width="column.width"
                            :sortable="column.sortable"
                            :groupable="column.groupable"
                            :formatter="column.formatter"
                          ></datatable-column>
                          <template slot="FirstName" scope="cell">
                            <label
                              for="FirstName"
                              style="width:100% !important"
                              @click="GetById(cell.row)"
                              class="Grid-field align-left form-control-sm gridLink"
                            >{{cell.row.FirstName}}</label>
                          </template>
                          <template slot="LastName" scope="cell">
                            <label
                              for="LastName"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.LastName}}</label>
                          </template>
                          <template slot="ContactNumber" scope="cell">
                            <label
                              for="ContactNumber"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.ContactNumber}}</label>
                          </template>
                          <!-- <template slot="Date" scope="cell">
                            <label
                              for="Date"
                              style="width:100% !important"
                              :Id="cell.row.Id + '_max'"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.Date}}</label>
                          </template>-->
                          <template slot="EmailId" scope="cell">
                            <label
                              for="EmailId"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.EmailId}}</label>
                          </template>
                          <template slot="UpdateDate" scope="cell">
                            <label
                              for="Intrest"
                              style="width:100% !important"
                              class="Grid-field align-left form-control-sm"
                            >{{cell.row.UpdateDate}}</label>
                          </template>
                          <!-- <template slot="Status" scope="cell" style="padding-left:10px;">
                            <label
                              class="CompletedStyle"
                              style="margin-left:15px;"
                              v-if="cell.row.Status.Id==3"
                            >
                              <i class="material-icons CompletedStyle">verified</i>
                              {{cell.row.Status.Name}}
                            </label>
                            <label
                              class="InprogressStyle"
                              style="margin-left:15px;"
                              v-if="cell.row.Status.Id==1"
                            >
                              <i class="material-icons InprogressStyle">pending</i>
                              {{cell.row.Status.Name}}
                            </label>
                            <label
                              class="graceStyle"
                              style="margin-left:15px;"
                              v-if="cell.row.Status.Id==2"
                            >
                              <i class="material-icons">error</i>
                              {{cell.row.Status.Name}}
                            </label>
                          </template>-->
                        </datatable>
                      </template>
                    </paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
export default {
  name: "Register",
  data() {
    return {
      Register: {
        PageType: "Master", // Master, Transaction, Dashboard, Tabb edDashboard
        PageLoad: true, // block/none
        DataModel: {
          Data: {
            Register: [],
            RegisterList: [],
            Id: 0,
            Date: null,
            Name: null,
            UnitPrice: null,
            UpdateDate: null,
            Amount: null,
            TransactionId: null,
            FirstName: null,
            LastName: null,
            EmailId: null,
            ContactNumber: null,
            City: null,
            Country: null,
            BankAccountNumber: null,
            AccountHolderName: null,
            AccountNo: null,
            IFSC: null,
            Status: "Updated",
            BatchId: 0,
            CustomerId: null,
            CompanyId: null,
            CreatedBy: 1
          },
          UIData: {}
        },
        PageState: "Default", // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
        TabInfo: {
          SelectedTabIndex: 0,
          NumberOfTabs: 0
        },
        SessionInfo: {
          SessionTimeout: false,
          AuthToken: "",
          SessionID: "",
          PageInfo: {
            ClientId: 0,
            userId: 0,
            WareHouseId: 0
          }
        },
        GridInfo: {
          RegisterInfoGrid: {
            filterInfo: {
              PageSize: 0,
              PageNumber: 0,
              HotelId: 0,
              CustomerName: null
            },
            AdditionalInfo: {
              striped: true,
              editable: false,
              lineNumbers: false,
              filter: null,
              currency: "USD",
              dateFormat: "D MMMM YYYY",
              selected: [],
              pageSize: 15,
              totalRows: 0
            },
            columns: [
              {
                id: "FirstName",
                label: "First Name",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: []
              },

              {
                id: "LastName",
                label: "Last Name",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: []
              },
              {
                id: "ContactNumber",
                label: "ContactNumber",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: []
              },
              {
                id: "EmailId",
                label: "Email ID",
                width: null,
                sortable: true,
                groupable: true,
                aggregators: []
              }
            ]
          }
        },
        Events: {
          EventRaised: "Submitted", // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
          PageToNavigateWhenSubmitted: "" // We can go back to dashboard or stay on the Same page or to a specific page
        },
        ValidationInfo: {},
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: ""
          }
        ],
        Masters: {},
        Modal: {},
        CharRestrict: {}
      }
    };
  },
  mounted() {
    this.ListRegister();
  },
  methods: {
    ListRegister() {
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Register.DataModel.Data.Token = Token;
      this.Register.DataModel.Data.CRUD = "List";
      var dataString = JSON.stringify(this.Register.DataModel.Data);
      axios
        .post(
          "APIScript/PHP/APIService/Registration/Registration.php",
          dataString
        )
        .then(function(response) {
          // return response;
          if (response.data.ErrorInfo == null) {
            vm.Register.DataModel.Data.RegisterList = response.data.Result;

            vm.Register.DataModel.Data.RegisterList.map(function(value, key) {
              value.UnitPrice = Utilities.TransactionCurrencyFormat(
                value.UnitPrice
              );
            });
          } else if (response.data.ErrorInfo == "Invalid Attempt") {
            this.$router.push({ name: "Login" });
          }
        })
        .catch(function(response) {
          console.log(response.data.ErrorInfo);
        });
    },
    GetById(data) {
      let vm = this;
      sessionStorage.setItem("SelectedRegisterID", data.Id);
      this.$router.push({ name: "RegisterView" });
    }
  }
};
</script>
